<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-10 0 310 300">
    <path
      fill="currentColor"
      d="M38 19l-19 19v225l19 18h225l18 -18v-225l-18 -19h-225zM38 263v-225h131v225h-131zM188 263v-225h75v225h-75z"
    />
  </svg>
</template>
